import React from "react";

/**
 * Certification seals for the Superior Standards section on Home.
 * Each seal is an AI-generated PNG (see /app/backend/generate_seal_images.py)
 * living at /public/seals/{slug}.png. Rendered as an <img> at ~88px so the
 * illustration + surrounding text on the badge are legible.
 */

const REGISTRY = {
  "AUS": { src: "/seals/australian.png", alt: "100% Australian certification seal" },
  "MSA": { src: "/seals/msa.png", alt: "MSA Graded Beef certification seal" },
  "HALAL": { src: "/seals/halal.png", alt: "Halal Certified seal" },
  "HACCP": { src: "/seals/haccp.png", alt: "HACCP Certified seal" },
  "HGP-FREE": { src: "/seals/no-hormones.png", alt: "No Added Hormones seal" },
  "PASTURE": { src: "/seals/pasture.png", alt: "Pasture Raised seal" },
  "EST. WA": { src: "/seals/perth.png", alt: "Perth Established seal" },
};

export function CertificationSeal({ label }) {
  const entry = REGISTRY[label];
  if (!entry) {
    return (
      <div
        className="w-20 h-20 shrink-0 rounded-full flex items-center justify-center bg-[color:var(--tbb-cream)] border-2 border-[color:var(--tbb-burgundy)] text-[color:var(--tbb-burgundy)] font-display text-[9px] font-black uppercase tracking-tight text-center px-1"
        aria-label={`${label} certification seal`}
      >
        {label}
      </div>
    );
  }
  return (
    <img
      src={entry.src}
      alt={entry.alt}
      className="w-20 h-20 md:w-24 md:h-24 shrink-0 object-contain"
      loading="lazy"
      data-testid={`seal-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`}
      onError={(e) => {
        // Simple textual fallback so a missing image never breaks the layout
        e.currentTarget.replaceWith(Object.assign(document.createElement("div"), {
          className: "w-20 h-20 shrink-0 rounded-full flex items-center justify-center bg-white border-2 border-[color:var(--tbb-burgundy)] text-[color:var(--tbb-burgundy)] font-black text-xs",
          textContent: label,
        }));
      }}
    />
  );
}
